import { createContext } from "preact";
import { useContext } from "preact/hooks";
import { Layout } from "./Layout.tsx";

export default function App(
  { children, vars }: { children?: preact.ComponentChildren, vars: Record<string, unknown> },
) {
  return (
    <AppDataContext.Provider value={new AppData()}>
      <Layout vars={vars}>{children}</Layout>
    </AppDataContext.Provider>
  );
}

class AppData { }

const AppDataContext = createContext<AppData | null>(null);

export const useAppData = () => useContext(AppDataContext) as AppData;
